import { render, staticRenderFns } from "./TransactionsExtraIncome.vue?vue&type=template&id=0a4f712f&"
import script from "./TransactionsExtraIncome.vue?vue&type=script&lang=js&"
export * from "./TransactionsExtraIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports